import React from 'react'
import PropTypes from 'prop-types'
import PageContainer from '../PageContainer/PageContainer'
import Note from '../Shared/Note/Note'
import BulletList from '../Shared/BulletList/BulletList'
import classnames from 'classnames'
import styles from './YourAccounts.module.scss'
import { defaultPrivateWealthEmail } from 'utils/links'
import { getFinancialAccountData, getAccountDisplayNameByType } from 'utils/financialAccountTypes'
import C from 'actionTypes/onboarding/routing'

const YourAccounts = (props) => {
  const primaryButtonClasses = classnames(
    'button',
    'button--primary',
    styles.submitButton,
  )

  const {
    goOnboardingAccountDetails,
    hide,
    isLoading,
    financialAccounts,
    isMobile
  } = props

  const prevPageInfo = {
    name: 'Employment Details',
    to: { type: C.ONBOARDING_EMPLOYMENT_DETAILS },
    showBackWord: false
  }

  const linkHref = `mailto:${defaultPrivateWealthEmail}`
  const ids = financialAccounts.map((financialAccount) => {
    const { attributes: { financialAccountType, subType } }  = financialAccount
    return getAccountDisplayNameByType(financialAccountType, subType)
  }).filter(account => account)


  const goNextSection = () => {
    if (financialAccounts.length <= 0) return
    const [{ id, attributes: { financialAccountType } }] = financialAccounts
    const accountTypeRoute = getFinancialAccountData(financialAccountType, 'RAW_TYPE').ACCOUNT_TYPE_ROUTE
    goOnboardingAccountDetails(id, accountTypeRoute)
  }

  return (
    <PageContainer
      name="Your Accounts"
      prevPageInfo={prevPageInfo}
      hide={hide || isLoading}
      isMobile={isMobile}
      isLoading={isLoading} >
      <div className={styles.YourAccounts}>
        <p className={styles.subDescription}>
          These are the Schwab accounts that you’ll need to review so we can confirm the details.
        </p>
        <Note className={styles.note}>
          <BulletList items={ids} />
        </Note>
        <div className={styles.bottomSection}>
          <button
            className={primaryButtonClasses}
            type="submit"
            onClick={goNextSection} >
            Continue
          </button>
          <div className={styles.contactUs}>
            Something not looking right? <a href={linkHref}>Contact </a>
            our Private Wealth Management team.
          </div>
        </div>
      </div>
    </PageContainer>
  )
}

YourAccounts.defaultProps = {
  financialAccounts: [],
}

YourAccounts.propTypes = {
  goOnboardingAccountDetails: PropTypes.func.isRequired,
  hide: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  financialAccounts: PropTypes.array,
}

export default YourAccounts



// WEBPACK FOOTER //
// ./src/components/Onboarding/YourAccounts/YourAccounts.jsx